export const passwordRulesLabel = 'Пароль должен состоять минимум из 8 символов, содержать как минимум одну цифру и 2 заглавные буквы'